import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { create as e, contains as i } from "../../../geometry/support/aaBoundingRect.js";
import t from "./TileCache.js";
import s from "./TileCoverage.js";
import l from "./TileKey.js";
var a = new l(0, 0, 0, 0),
    h = new Map(),
    o = [],
    c = [];

var r = /*#__PURE__*/function () {
  function r(e) {
    var _this = this;

    _classCallCheck(this, r);

    this._previousScale = Number.POSITIVE_INFINITY, this.cachePolicy = "keep", this.coveragePolicy = "closest", this.resampling = !0, this.tileIndex = new Map(), this.tiles = [], this.buffer = 192, this.acquireTile = e.acquireTile, this.releaseTile = e.releaseTile, this.tileInfoView = e.tileInfoView, this.resampling = null == e.resampling || !!e.resampling, e.cachePolicy && (this.cachePolicy = e.cachePolicy), e.coveragePolicy && (this.coveragePolicy = e.coveragePolicy), null != e.buffer && (this.buffer = e.buffer), e.cacheSize && (this._tileCache = new t(e.cacheSize, this.tileInfoView, function (e) {
      _this.releaseTile(e);
    }));
  }

  _createClass(r, [{
    key: "destroy",
    value: function destroy() {
      this.tileIndex.clear();
    }
  }, {
    key: "update",
    value: function update(e) {
      var _this2 = this;

      var i = this.resampling,
          t = this.tileIndex,
          l = this.tileInfoView.getTileCoverage(e.state, this.buffer, this.coveragePolicy);
      if (c.length = 0, o.length = 0, h.clear(), !l) return;
      var _this$tileInfoView$ti = this.tileInfoView.tileInfo,
          _r = _this$tileInfoView$ti.minScale,
          n = _this$tileInfoView$ti.maxScale,
          f = l.spans,
          d = l.lodInfo,
          u = d.level,
          _e$state = e.state,
          p = _e$state.scale,
          g = _e$state.center,
          y = _e$state.resolution,
          I = !e.stationary && p > this._previousScale;
      if (this._previousScale = p, this.tiles.length = 0, !i && (p > _r || p < n)) return this.tiles.length = 0, h.clear(), t.forEach(function (e) {
        _this2.releaseTile(e);
      }), t.clear(), c.length = 0, o.length = 0, h.clear(), s.pool.release(l), !0;
      t.forEach(function (e) {
        return e.visible = !0;
      });
      var T = 0,
          _ = 0;

      if (f.length > 0) {
        var _iterator = _createForOfIteratorHelper(f),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _step.value,
                _s = _step$value.row,
                _o = _step$value.colFrom,
                _c = _step$value.colTo;

            for (var _e = _o; _e <= _c; _e++) {
              T++;
              var _i = a.set(u, _s, d.normalizeCol(_e), d.getWorldForColumn(_e)).id;

              if (t.has(_i)) {
                var _e2 = t.get(_i);

                _e2.isReady ? (h.set(_i, _e2), _++) : I || this._addParentTile(_i, h);
              } else {
                var _e3 = void 0;

                if (this._tileCache && this._tileCache.has(_i)) {
                  if (_e3 = this._tileCache.pop(_i), this.tileIndex.set(_i, _e3), _e3.isReady) {
                    h.set(_i, _e3), _++;
                    continue;
                  }
                } else _e3 = this.acquireTile(a), this.tileIndex.set(_i, _e3);

                I || this._addParentTile(_i, h);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var m = _ === T;
      t.forEach(function (e, i) {
        if (a.set(i), h.has(i)) return;

        var t = _this2.tileInfoView.intersects(l, a),
            s = "purge" === _this2.cachePolicy ? a.level !== u : a.level > u;

        !t || !I && m ? !s && t || o.push(i) : e.isReady ? s && "purge" === _this2.cachePolicy && _this2._hasReadyAncestor(a, u) ? o.push(i) : c.push(i) : s && o.push(i);
      });

      var _iterator2 = _createForOfIteratorHelper(c),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _s2 = _step2.value;

          var _e4 = t.get(_s2);

          _e4 && _e4.isReady && h.set(_s2, _e4);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(o),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _s3 = _step3.value;

          var _e5 = t.get(_s3);

          this._tileCache ? this._tileCache.add(_e5) : this.releaseTile(_e5), t.delete(_s3);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return h.forEach(function (e) {
        return _this2.tiles.push(e);
      }), t.forEach(function (e) {
        h.has(e.key.id) || (e.visible = !1);
      }), this._tileCache && this._tileCache.prune(u, g, y), s.pool.release(l), h.clear(), m;
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this3 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      var i = this.tileIndex;
      e && i.forEach(function (e) {
        _this3.releaseTile(e);
      }), i.clear();
    }
  }, {
    key: "updateCacheSize",
    value: function updateCacheSize(e) {
      this._tileCache && (this._tileCache.maxSize = e);
    }
  }, {
    key: "_addParentTile",
    value: function _addParentTile(e, i) {
      var t = e,
          s = null;

      for (; t = this.tileInfoView.getTileParentId(t), t;) {
        if (this.tileIndex.has(t)) {
          if (s = this.tileIndex.get(t), s && s.isReady) {
            i.has(s.key.id) || i.set(s.key.id, s);
            break;
          }
        } else if (this._tileCache && this._tileCache.has(t) && (s = this._tileCache.pop(t), this.tileIndex.set(t, s), s && s.isReady)) {
          i.has(s.key.id) || i.set(s.key.id, s);
          break;
        }
      }
    }
  }, {
    key: "_hasReadyAncestor",
    value: function _hasReadyAncestor(t, s) {
      var l = e();
      this.tileInfoView.getTileBounds(l, t, !0);

      var _iterator4 = _createForOfIteratorHelper(this.tileIndex.values()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _a = _step4.value;

          if (_a.isReady && _a.key.level >= s && _a.key.level < t.level) {
            var _t = e();

            if (this.tileInfoView.getTileBounds(_t, _a.key, !0), i(_t, l)) return !0;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return !1;
    }
  }]);

  return r;
}();

export { r as default };